import { render, staticRenderFns } from "./voicechoose.vue?vue&type=template&id=6f04058e&scoped=true"
import script from "./voicechoose.vue?vue&type=script&lang=js"
export * from "./voicechoose.vue?vue&type=script&lang=js"
import style0 from "./voicechoose.vue?vue&type=style&index=0&id=6f04058e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04058e",
  null
  
)

export default component.exports